export default __webpack_public_path__ + "static/media/kokilab.12d06750.ttf";